export default "__VITE_ASSET__B8ElZ4nU__"